<script>
  import {
    VCardActions
  } from 'vuetify/lib'
  export default {
    name: 'wh-card-actions',
    extends: VCardActions
  };
</script>